import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Banner, BannerIcon } from '../../types/banner.type';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  public banner: Banner = {};

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['submitSuccess'] == 1) {
        this.banner.header = 'Message sent!';
        this.banner.message =
          'Our friendly team will be in touch with you soon';
        this.banner.style = 'success';
        this.banner.icon = BannerIcon.SUCCESS;
      }
    });
  }
}
